<template>
  <div>
    <v-text-field
      v-model="currentValue"
      v-show="!hiddenField(access)"
      v-mask="currentMask()"
      autocomplete="off"
      :id="id"
      :label="label"
      :type="fieldTextType(dataType)"
      :required="requiredField(access)"
      :readonly="readonlyField(access)"
      :prefix="prefix"
      :suffix="suffix"
      :progress="toAssign"
      :filled="readonlyField(access) || queryFlag"
      :rules="rules"
      :append-icon="appendIcon()"
      :maxLength="maxLength()"
      :minLength="minLength()"
      :outlined="queryFlag"
      :single-line="queryFlag"
      :hide-details="queryFlag"
      :dense="queryFlag"
      :hint="hint"
      :class="dynamicClass({ type: 'number', customStyle, queryFlag })"
      :style="dynamicStyle({ customStyle })"
      @input="() => handleChange(null)"
      @keydown="(k) => handleKeyDown(k, id)"
      @click:append-outer="appendOuterClick()"
      @blur="handleBlur"
      @focus="handleFocus"
    />
  </div>
</template>

<script>
export default {
  name: "NumberField",
  props: [
    "label",
    "value",
    "access",
    "dataType",
    "id",
    "name",
    "prefix",
    "suffix",
    "toAssign",
    "rules",
    "foreignKey",
    "browseHelp",
    "inputFields",
    "mask",
    "length",
    "secLength",
    "upperLower",
    "queryFlag",
    "coordinates",
    "hint",
    "customStyle",
  ],
  data() {
    return {
      defaultValue: this.value,
      currentValue: this.formatReal(this.value, this.length, this.secLength),
      numericValue: this.value ? parseFloat(this.value) : null,
      //autoSource: null,
      colorPri: "red",
      colorSec: "magenta",
      colorTer: "cyan",
    };
  },
  methods: {
    handleChange(autoSource) {
      if (this.notBlank(this.currentValue)) {
        this.currentValue = this.currentValue.replace(/[^\d.-]/g, "");
        const numericTemp = parseFloat(this.currentValue);
        this.numericValue = !isNaN(numericTemp) ? numericTemp : 0;
      } else {
        this.currentValue = null;
        this.numericValue = null;
      }
      const data = {
        value: this.numericValue,
        id: this.id,
        autoSource, //: this.autoSource,
        coordinates: this.coordinates,
      };
      this.$emit("field-change", data);
    },
    handleKeyDown(key, id) {
      if (this.notBlank(this.foreignKey)) {
        if (key.key.toLowerCase() == "enter") {
          this.doForeignKey();
        }
      } else {
        this.$emit("handle-key-down", key.key, id);
      }
    },
    handleBlur() {
      if (this.currentValue != null) {
        this.numericValue = parseFloat(this.currentValue);
        this.currentValue = this.formatReal(
          this.numericValue,
          this.length,
          this.secLength
        );
      } else {
        this.numericValue = null;
      }
    },
    handleFocus() {
      this.currentValue = this.numericValue;
    },
    appendIcon() {
      if (this.notBlank(this.foreignKey)) {
        if (this.currentValue) {
          return "mdi-check-circle-outline";
        } else {
          return "mdi-dots-horizontal-circle-outline";
        }
      }
    },
    appendOuterIcon() {
      if (this.notBlank(this.browseHelp)) {
        return "mdi-magnify";
      }
    },
    setValue(value, autoSource) {
      this.currentValue = value == null
        ? null
        : typeof value != "string"
        ? value.toString()
        : value;
      this.handleChange(autoSource);
    },
    currentMask() {
      const result = this.okMask() ? this.mask : null;
      return result;
    },
    okMask() {
      return this.mask && !this.fieldReal(this.dataType);
    },
    okNumberMask() {
      return this.fieldReal(this.dataType);
    },
    maxLength() {
      let result = this.length;
      if (this.fieldReal(this.dataType)) {
        result =
          (this.length ? this.length : 3) +
          (this.secLength ? this.secLength : 0) +
          (this.secLength ? 1 : 0);
      } else if (this.fieldInteger(this.dataType)) {
        result = this.length;
      }
      return result;
    },
    minLength() {
      return !this.fieldTextType(this.dataType) != "number"
        ? this.secLength
        : null;
    },
  },
  updated() {},
  mounted() {},
};
</script>

<style scoped>
.query-flag {
  font-size: 0.9em;
}
.custom-number-style >>> .v-text-field__slot label {
  color: var(--label-color);
  background-color: var(--label-background-color);
  font-size: var(--label-size);
  border: var(--label-border);
  border-radius: var(--label-border-radius);
}
.custom-number-style >>> .v-text-field__slot input {
  color: var(--input-color);
  background-color: var(--input-background-color);
  font-size: var(--input-size);
  border: var(--input-border);
  border-radius: var(--input-border-radius);
}
.custom-number-style >>> .v-text-field__slot .v-text-field__prefix {
  color: var(--prefix-color);
  background-color: var(--prefix-background-color);
  font-size: var(--prefix-size);
  border: var(--prefix-border);
  border-radius: var(--prefix-border-radius);
}
.custom-number-style >>> .v-text-field__slot {
  color: var(--slot-color);
  background-color: var(--slot-background-color);
  font-size: var(--slot-size);
  padding: var(--slot-padding);
  margin: var(--slot-margin);
  border: var(--slot-border);
  border-radius: var(--slot-border-radius);
}

.custom-number-style {
  color: var(--field-color);
  background-color: var(--field-background-color);
  font-size: var(--field-size);
  padding: var(--field-padding);
  margin: var(--field-margin);
  border: var(--field-border);
  border-radius: var(--field-border-radius);
}
</style>